import { useState, useCallback, useEffect } from "react";
import employeeLeaveBalanceService from "../services/employeeLeaveBalanceService";
import { useGeneralMessage } from "../../common/APICommon";

export const useEmployeeLeaveBalance = (employeePersonalInformationId) => {
  const [loading, setLoading] = useState(false);
  const [employeeLeaveCredits, setEmployeeLeaveCredits] = useState([]);
  const [currentYearDisplay, setCurrentYearDisplay] = useState(null); // MODIFIED: For display only
  const [selectedEmployeeLeaveCredit, setSelectedEmployeeLeaveCredit] = useState(null);

  const { showGeneralMessage, showMessage, message, isSuccess } = useGeneralMessage();

  const fetchData = useCallback(async () => {
    if (!employeePersonalInformationId) return;
    
    setLoading(true);
    try {
      const res = await employeeLeaveBalanceService.getByEmployee(employeePersonalInformationId);
      setEmployeeLeaveCredits(res.data);
      
      if (res.data.length > 0) {
        setCurrentYearDisplay(res.data[0].currentYearReference);
      }
    } catch (err) {
      const errorMsg = err.response?.data?.message || "Failed to load leave balances";
      showGeneralMessage(errorMsg, false);
      setCurrentYearDisplay(null);
    } finally {
      setLoading(false);
    }
  }, [employeePersonalInformationId, showGeneralMessage]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const updateLocalBalance = (leaveTypeId, field, value) => {
    setEmployeeLeaveCredits(prev => prev.map(item =>
      item.leaveTypeId === leaveTypeId ? { ...item, [field]: value } : item
    ));
  };

  const executeSave = async (formData) => {
    // Note: No more local year injection. Backend handles it.
    try {
      const { currentYearReference, ...payload } = formData; // MODIFIED: Clean payload

      if (!formData.id || formData.id === 0) {
        await employeeLeaveBalanceService.create(payload);
      } else {
        await employeeLeaveBalanceService.update(formData.id, payload);
      }
      showGeneralMessage("Leave Credit/s updated successfully", true);
      fetchData(); 
    } catch (err) {
      const errorMsg = err.response?.data?.message || "An error occurred";
      showGeneralMessage(errorMsg, false);
    }
  };

  return {
    loading,
    employeeLeaveCredits,
    currentYear: currentYearDisplay, // Exported for UI Tooltips
    selectedEmployeeLeaveCredit, 
    setSelectedEmployeeLeaveCredit,
    showMessage, message, isSuccess,
    updateLocalBalance,
    executeSave,
    fetchBalances: fetchData
  };
};